// src/components/Blogs.js

// ------------------
import React from "react";

import { Link } from "react-router-dom";

import "../assets/styles/work.css";

function About() {
  return (
    <div className="about-content-container">
      <section className="notes-section">
        <div className="work-content">
          <div className="about-work-inner-container">
            <p className="work-intro">
              I am a Research Engineer at{" "}
              <a
                href="https://en.wikipedia.org/wiki/Meta_Superintelligence_Labs"
                target="_blank"
                rel="noopener noreferrer"
              >
                MSL TBD Labs
              </a>{" "}
              working on Superintelligence.
            </p>
            <ul className="career-research-links">
              <li>
                <Link to="/work" className="blog-link">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/career" className="blog-link">
                  Career Log Graph
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
// ------------------
